import { useTheme } from 'styled-components/macro';
import { colors } from '../Style/Theme';
import { hexToRgb } from '../Utils/utils';

const defaultStripeBoxShadow =
  '0px 1px 1px rgba(0, 0, 0, 0.03), 0px 3px 6px rgba(0, 0, 0, 0.02)';

const useStripeAppearance = () => {
  const theme = useTheme();

  const stripeAppearance = {
    variables: {
      fontFamily: 'Faro-Regular, sans-serif',
      fontSizeBase: '14px',
      colorPrimary: theme.colors.primary,
      colorBackground: colors.white,
      colorText: theme.colors.primary,
      colorTextSecondary: colors.gray,
      colorTextPlaceholder: colors.gray,
      colorSuccess: colors.green,
      colorDanger: colors.red,
      borderRadius: theme.inputs.borderRadius,
    },
    rules: {
      '.Input': {
        borderColor: colors.lightGray,
      },
      '.Input:focus': {
        borderColor: theme.colors.primary,
        boxShadow: `0 0 0 3px ${hexToRgb(theme.colors.primary, { opacity: 25 })}`,
      },
      '.Input--invalid': {
        borderColor: colors.red,
        boxShadow: defaultStripeBoxShadow,
      },
      '.Input--invalid:focus': {
        borderColor: colors.red,
        boxShadow: `0 0 0 3px ${hexToRgb(colors.red, { opacity: 25 })}`,
      },
    },
  };

  return stripeAppearance;
};

export default useStripeAppearance;
